import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
} from '@angular/core';
import 'owl.carousel';
import { SlideDirective } from './slide.directive';
import { OwlCarouselOptions } from './owl-carousel-options';

declare var $: any;

@Component({
  selector: 'lp2-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(SlideDirective)
  slides: QueryList<SlideDirective>;

  @Input()
  settings: OwlCarouselOptions;

  @Input()
  title: string;

  @Input()
  showNewBadge = false;

  @Input()
  gamificationData: {
    points: number;
  };

  @Output()
  translate = new EventEmitter();

  private currentIndex = 0;

  isLoading = true;

  private $el: any;

  constructor(private readonly el: ElementRef) {}

  destroy() {
    this.isLoading = true;
    return new Promise((resolve) => {
      if (this.$el.hasClass('owl-loaded')) {
        this.$el.owlCarousel('destroy');
        this.$el.find('.owl-item,.owl-stage').remove();
        resolve(null);
      }
    });
  }

  ngAfterContentInit() {
    this.$el = $(this.el.nativeElement).find('.owl-carousel');

    this.initiateCarousel();

    this.slides.changes.subscribe(async () => {
      await this.destroy();
      this.initiateCarousel();
      this.moveCarouselToIndex(this.currentIndex);
    });

    this.$el.on('translated.owl.carousel', (event) => {
      this.moveCarouselToIndex(event.item.index);
      this.lazyLoadHelper(event);
      this.translate.emit(event);
    });

    this.$el.on('refreshed.owl.carousel', this.lazyLoadHelper);

    this.moveCarouselToIndex(0);
  }

  private moveCarouselToIndex(index: number) {
    this.currentIndex = index;
    this.$el.trigger('to.owl.carousel', [this.currentIndex, 0, true]);
  }

  initiateCarousel() {
    this.$el.on('initialized.owl.carousel', (e) => {
      this.lazyLoadHelper(e);
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    });
    this.settings.navText = ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'];
    this.settings.mouseDrag = false;
    this.settings.rewind = false;
    this.settings.navSpeed = 150;
    this.$el.owlCarousel(this.settings);
  }

  lazyLoadHelper(event) {
    const peekAheadEl = $(event.target).find('.owl-item.active:last + .owl-item');
    // check for a data-src attribute
    const dataSrcImgUrl = peekAheadEl.find('[data-src]').attr('data-src');
    if (dataSrcImgUrl) {
      peekAheadEl.find('[data-src]').css('background-image', `url(${dataSrcImgUrl})`).css('opacity', 1);
    }
  }

  ngOnDestroy() {
    this.destroy();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/carousel/carousel.component.ts